{
  "actions": "Radnje",
  "actionsAvailable": "Dostupne su radnje.",
  "clearSelection": "Poništi izbor",
  "selected": "{count, plural, =0 {Ništa nije izabrano} other {# je izabrano}}",
  "selectedAll": "Sve je izabrano"
}
